import store from "../storeTs";

export default async (to, from, next) => {
  if (store.getters.currentUser.rol === 2) {
    next({ name: "401" });
  } else {
    next();
  }
};
